import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const approvalRequestKpiIndividualListService = (
  params: Types.ApprovalRequestKpiIndividualListRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestKpiIndividualListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const approvalRequestKpiIndividualCreateService = (
  params: Types.ApprovalRequestKpiIndividualCreateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestKpiIndividualUpdateService = (
  params: Types.ApprovalRequestKpiIndividualUpdateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestKpiIndividualDetailService = (id: string) =>
  RestAPIClient.call<Types.ApprovalRequestKpiIndividual>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const approvalRequestKpiIndividualApproveService = (
  params: Types.ApprovalRequestKpiIndividualApproveRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestKpiIndividual>({
    method: HTTPRequestMethods.POST,
    url: Paths.Approve,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
